import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BicycleIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BicycleIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.10839 3.375H10.22C10.9156 3.375 11.4797 3.92891 11.4797 4.61233V6.28635H19.3495C19.4995 6.28635 19.6427 6.31187 19.7751 6.35847L20.0487 4.75791H17.995C17.7086 4.75791 17.4764 4.52981 17.4764 4.24842C17.4764 3.96703 17.7086 3.73892 17.995 3.73892H20.6616C20.8142 3.73892 20.959 3.80492 21.0575 3.91935C21.156 4.03377 21.1983 4.18502 21.173 4.33283L20.514 8.18704L19.6856 13.0687C20.3146 13.3997 20.7429 14.0516 20.7429 14.8021C20.7429 15.8875 19.8471 16.7672 18.7421 16.7672C17.6372 16.7672 16.7414 15.8875 16.7414 14.8021C16.7414 14.5414 16.7931 14.2924 16.8871 14.0644L16.8799 14.057L16.8735 14.0501L11.2187 7.84276L10.6344 10.0343C12.7677 10.7966 14.2914 12.8065 14.2914 15.1661C14.2914 16.9771 13.3939 18.582 12.0122 19.5751H17.0552C17.3451 19.5751 17.5802 19.8101 17.5802 20.1001C17.5802 20.39 17.3451 20.6251 17.0552 20.6251H8.58018C8.55694 20.6251 8.53406 20.6236 8.51162 20.6206C5.54727 20.5051 3.18018 18.1072 3.18018 15.1661C3.18018 12.1513 5.6675 9.70726 8.73577 9.70726C9.04024 9.70726 9.33899 9.73132 9.63015 9.77762L10.4424 6.73041V4.61233C10.4424 4.4918 10.3429 4.39398 10.22 4.39398H9.10888C8.94562 4.39432 8.59711 4.41358 8.3025 4.58069C8.17237 4.65452 8.04302 4.76222 7.94501 4.93301C7.8466 5.10449 7.77442 5.34895 7.77442 5.70409C7.77442 6.44907 8.02869 6.75388 8.23737 6.88997C8.47853 7.04724 8.79171 7.06631 9.00668 7.02409C9.28751 6.96892 9.56079 7.14779 9.61699 7.42375C9.67319 7.69973 9.49095 7.96811 9.2101 8.02328C8.80783 8.1023 8.19458 8.08517 7.66359 7.73889C7.09999 7.37133 6.73706 6.70541 6.73706 5.70409C6.73706 4.6571 7.19914 4.02991 7.78373 3.69829C8.32243 3.3927 8.90073 3.37539 9.10839 3.375ZM8.57687 13.7293L9.34699 10.84C9.14718 10.813 8.94314 10.799 8.73577 10.799C6.28116 10.799 4.2913 12.7542 4.2913 15.1661C4.2913 17.578 6.28116 19.5332 8.73577 19.5332C11.1904 19.5332 13.1803 17.578 13.1803 15.1661C13.1803 13.3142 12.0071 11.7315 10.3512 11.0965L9.58238 13.98C9.86146 14.2025 10.0402 14.5425 10.0402 14.9235C10.0402 15.5944 9.4865 16.1381 8.80361 16.1381C8.12072 16.1381 7.56702 15.5944 7.56702 14.9235C7.56702 14.3287 8.00219 13.834 8.57687 13.7293ZM19.4502 8.25849L18.6672 12.8383C18.2395 12.8537 17.846 13.0012 17.5278 13.2402L12.1212 7.30533H19.3495C19.487 7.30533 19.5914 7.42655 19.5688 7.55957L19.4502 8.25849ZM18.7421 15.7483C19.2743 15.7483 19.7056 15.3246 19.7056 14.8021C19.7056 14.2796 19.2743 13.8559 18.7421 13.8559C18.21 13.8559 17.7787 14.2796 17.7787 14.8021C17.7787 15.3246 18.21 15.7483 18.7421 15.7483ZM8.80361 15.1343C8.92223 15.1343 9.01828 15.0399 9.01828 14.9235C9.01828 14.8072 8.92223 14.7127 8.80361 14.7127C8.685 14.7127 8.58895 14.8072 8.58895 14.9235C8.58895 15.0399 8.685 15.1343 8.80361 15.1343Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BicycleIcon;
